import { render, staticRenderFns } from "./ClientDetails.vue?vue&type=template&id=c3705bb2&"
import script from "./ClientDetails.vue?vue&type=script&lang=ts&"
export * from "./ClientDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports